import './style.scss'
import { InstructorSearchResultProfile } from '../../server/types';
import { getProfilePicPath, getSmallProfilePicPath } from '../../constants/instructorConstants';
import { PAGE_URLS } from '../../constants/hrefLinks';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { userStateData } from '../../data/userStateData';
import { updateLikedProfiles } from '../../redux/reducers/searchSlice';
import { LazyLoadImage } from 'react-lazy-load-image-component'

interface SearchResultProfileProps {
	profile: InstructorSearchResultProfile
}

function SearchResultProfile({profile}: SearchResultProfileProps) {
	const likedProfiles: string[] = useAppSelector(state => state.search.likedProfiles)
	const renderProfileLikes: number = useAppSelector(state => state.search.renderProfileLikes)
	const innerWidth: number = useAppSelector(state => state.resize.innerWidth)
	
	const dispatch = useAppDispatch()

	const toggleProfileLike = (profileId: string) => {
		userStateData.toggleLikesInstructor(profileId)
		dispatch(updateLikedProfiles())
	}

	const profileLiked = ():boolean => {
		let isLiked: boolean = false
		likedProfiles.forEach((value: string) => {
			if (value == profile.id) {
				isLiked = true
			}
		})
		return isLiked
	}

	return (
		<div
			className="seach-result-profile-wrap"
		>
			<a
				href={`${PAGE_URLS.INSTRUCTOR}?id=${profile.id}`}
				aria-label={`Visit the profile page for Instructor ${profile.name}`}
			>
				{/* <img 
					className='seach-result-profile-img'
					src={getProfilePicPath(profile.profile_pics, 0)}
					alt='Instructor profile'
					loading="lazy"
				/> */}
				<LazyLoadImage
					className='seach-result-profile-img'
					src={innerWidth < 500 ? getSmallProfilePicPath(profile.profile_pics, 0) : getProfilePicPath(profile.profile_pics, 0)}
					alt='Instructor profile'
					loading="lazy"
					fetchPriority='high'
					// placeholderSrc='/imgs/placeholder/profile_place_holder.jpeg'
				/>
			</a>
			<div className='search-result-profile-details-wrap'>
				<div className='seach-result-profile-name'>{profile.name}
					<div className='search-result-profile-rating'>
						{Number(profile.rating_overall) > 0 &&
							<>
								<img 
									src={`/imgs/icons/icon-star.svg`}
									className='search-result-profile-rating-icon'
									alt={`Rating star`}
								/>
								{profile.rating_overall}
							</>
						}
					</div>
				</div>
				{/* <div className='seach-result-profile-school'>{INSTRUCTOR_SCHOOLS[profile.school].toLowerCase() == 'none' ? '' : INSTRUCTOR_SCHOOLS[profile.school]}</div> */}
				<div className={`seach-result-profile-level-pill seach-result-profile-level-pill-level-${profile.level}`}>Level {profile.level}</div>
				<div className='seach-result-profile-price-wrap'>
					<div className='seach-result-profile-price-value'>{`$${profile.price}`}<span className='currency-txt'> NZD</span></div>
					<div className='seach-result-profile-price-label'> / session</div>
					{renderProfileLikes &&
						<img
							className='seach-result-profile-price-like-button'
							// src='/imgs/icons/icon-heart-empty.svg'
							// src={Math.random() > 0.7 ? '/imgs/icons/icon-heart-filled.svg' : '/imgs/icons/icon-heart-empty.svg'}
							src={profileLiked() ? '/imgs/icons/icon-heart-filled.svg' : '/imgs/icons/icon-heart-empty.svg'}
							alt='Heart'
							onClick={() => toggleProfileLike(profile.id)}
						/>
					}
				</div>
			</div>
		</div>
	)
}

export default SearchResultProfile
